module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image14.fbd44188.webp";